import React, { useEffect } from "react";
import { Card, CardHeader, CardBody, Image } from "@heroui/react";
import { motion } from "framer-motion";
import { fixWidows } from "utils/const";
import { useData } from "../contexts/DataContext";

function Zsurik() {
  const { jurys } = useData();

  useEffect(() => {
    localStorage.removeItem("name");
  }, []);
  return (
    <div className="min-h-screen bg-black text-white px-4 sm:px-10 py-10">
      <h1 className="text-3xl sm:text-5xl font-bold text-center mb-12">
        Zsűri
      </h1>

      <div className="flex flex-wrap justify-center gap-8">
        {jurys.map((zsuri, index) => (
          <motion.div
            key={index}
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.1 }}
          >
            <Card className="bg-gray-900 border border-gray-700 shadow-lg overflow-hidden w-full max-w-[500px]">
              <CardHeader className="p-0 items-center justify-center">
                <Image
                  src={zsuri.img || zsuri.image}
                  alt={zsuri.name}
                  className="w-full h-64 object-cover"
                />
              </CardHeader>
              <CardBody className="p-6">
                <h2 className="text-white text-2xl font-semibold">
                  {zsuri.name}
                </h2>
                <p className="text-gray-400 mb-4">{zsuri.work || zsuri.title}</p>
                <p className="text-gray-300 " lang="hu">
                  {fixWidows(zsuri.desc || zsuri.description || "")}
                </p>
              </CardBody>
            </Card>
          </motion.div>
        ))}
      </div>
    </div>
  );
}

export default Zsurik;
